import axios from "axios";
import { getJWT, HandleUserLogout } from "../Helpers";
import { ErrorToast, TechnicalIssuesMessage } from "../components/v2/utils/Toast";
import { MacsAuthenticator } from "../hooks/useMacsAuthenticator";
import { Role } from "../enums";

const baseURL = process.env.REACT_APP_BACKEND_API;
if (!baseURL) {
  throw Error("REACT_APP_BACKEND_API not defined.");
}

const instance = axios.create({
  withCredentials: true,
  baseURL,
});

instance.interceptors.request.use(
  async function (config) {
    let jwt = undefined;
    try {
      jwt = await getJWT();
    } catch (e) {
      console.log("axios request error in getting JWT", e);
    }
    config.headers = {
      ...config.headers,
      ...(jwt && !MacsAuthenticator.authHook.sessionId
        ? { Authorization: `Bearer ${jwt}` }
        : {}),
      // pass current selected class to backend as header for submission, userevent, etc filtering
      ...(MacsAuthenticator.authHook.currentUserRole === Role.student &&
        MacsAuthenticator.authHook.studentCurrentClassId && {
          "x-current-class-id": MacsAuthenticator.authHook.studentCurrentClassId,
        }),
      // we pass the ID as a header so that the authorizor can compare this tab's ID to the auth cookie
      // since we can't access the HTTP only cookies from React
      // necessary so we can kick out the user's session if there's a mismatch via logging in under a different tab
      ...(MacsAuthenticator.authHook.currentUserId &&
        MacsAuthenticator.authHook.authType && {
          "x-current-user-id": MacsAuthenticator.authHook.currentUserId,
          "x-auth-type": MacsAuthenticator.authHook.authType,
        }),
      ...(MacsAuthenticator.authHook.sessionId && {
        "x-auth-session-id": MacsAuthenticator.authHook.sessionId,
      }),
      ...(MacsAuthenticator.authHook.isStudentView && {
        "x-is-student-view": MacsAuthenticator.authHook.isStudentView,
      }),
    };
    return config;
  },
  function (error) {
    // Do something with request error
    console.log("axios request error", error);
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    console.log("axios response", response);
    let responseHeaders = response.headers;
    if (responseHeaders["x-auth-type"]) {
    }
    if (responseHeaders["x-auth-token-expiry"]) {
      console.log(
        "InactivityManager.setTokenExpiry",
        responseHeaders["x-auth-token-expiry"]
      );
      // MacsAuthenticator.authHook.setExp(Number(responseHeaders["x-auth-token-expiry"]));
    }
    if (responseHeaders["x-token-refreshes-remaining"]) {
      console.log(
        "InactivityManager.setTokenRefreshRemaining",
        responseHeaders["x-token-refreshes-remaining"]
      );
      // MacsAuthenticator.authHook.setRefreshesRemaining(
      //   Number(responseHeaders["x-token-refreshes-remaining"])
      // );
    } else {
      // MacsAuthenticator.authHook.setRefreshesRemaining(0);
    }
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    console.log("axios response error", error);
    if (error.code === "ERR_NETWORK") {
      ErrorToast("The network connection is lost. Please check your system settings.");
      return Promise.reject();
    }
    if (error.response.status === 500) {
      ErrorToast(TechnicalIssuesMessage());
      return Promise.reject();
    }
    // Detected a token mismatch, probably logged into multiple accounts in different tabs
    // Force a refresh to discard current session
    if (
      ((error.response.status === 403 &&
        error.response.data.message &&
        error.response.data.message === "Forbidden") ||
        (error.response.status === 401 &&
          error.response.data.message &&
          error.response.data.message === "Unauthorized") ||
        (error.response.status === 401 &&
          error.response.data.error &&
          error.response.data.error === "Unauthorized")) &&
      MacsAuthenticator.authHook.authenticated
    ) {
      console.warn(
        "Mid session authentication error, clearing session and redirecting to session end"
      );
      HandleUserLogout({
        redirectToSessionEnd: true,
      });
    }
    return Promise.reject(error);
  }
);

export default instance;
